import axios from '@/http/axios/index.js'


export default {
    getDashboardStatus(payload) {
        return axios.get('rps/dashboard/status-total', { params: payload }).then(res => res.data)
    },
     getDashboardVendors(payload) {
        return axios.get('rps/dashboard/vendors-total', { params: payload }).then(res => res.data)
    },
     getDashboardRequestMonth(payload) {
        return axios.get('rps/dashboard/requested-by-month', { params: payload }).then(res => res.data)
    },
    getDashboardVendorRequest(payload) {
        return axios.get('rps/dashboard/vendor-request', { params: payload }).then(res => res.data)
    },
}